import { render, staticRenderFns } from "./activityDeclaration.vue?vue&type=template&id=58873526&scoped=true"
import script from "./activityDeclaration.vue?vue&type=script&lang=js"
export * from "./activityDeclaration.vue?vue&type=script&lang=js"
import style0 from "./activityDeclaration.vue?vue&type=style&index=0&id=58873526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58873526",
  null
  
)

export default component.exports